"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { useTrackPlanCtaClicked } from "@/lib/analytics/hooks";
import { registroHref, type PricingPlan } from "@/lib/pricing/plan-slug";

type PlanCtaLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  plan: PricingPlan;
  href?: string;
};

/** Public plan CTA: links to /registro/{plan} and tracks `plan_cta_clicked`. */
export function PlanCtaLink({
  plan,
  href,
  onClick,
  ...props
}: PlanCtaLinkProps) {
  const trackPlanCtaClicked = useTrackPlanCtaClicked();

  return (
    <Link
      href={href ?? registroHref(plan)}
      onClick={(event) => {
        trackPlanCtaClicked({ plan, source_path: window.location.pathname });
        onClick?.(event);
      }}
      {...props}
    />
  );
}
